<!--nh-nav></nh-nav-->

<app-masthead [title]="hero.title" [subtitle]="hero.subtitle" [image]="hero.image"></app-masthead>

<section class="blog-shell">
  <div class="container">
    <div class="controls">
      <app-breadcrumbs></app-breadcrumbs>
      <app-search-filter [entries]="entriesAll" (searchChange)="search = $event"  (filterChange)="filter = $event"></app-search-filter>
      <app-newsletter-banner></app-newsletter-banner>
    </div>
    <app-blog-entries [entries]="filtered" (openEntry)="openEntry($event)"></app-blog-entries>
    <div class="blog-footer-cta">
      <div class="cf-wrapper">
        <app-contact-form></app-contact-form>
      </div>
      <app-newsletter-banner></app-newsletter-banner>
      <app-social
        heading="Let&rsquo;s make it official"
        subheading="Follow me on these platforms:"
        enabled="linkedin, twitter, behance"
      >
      </app-social>
    </div>
  </div>
</section>
<!--app-related-entries [entries]="entries.slice(0,3)"></app-related-entries-->
<nh-footer></nh-footer>
